export default {
  CAPITAL_DECREASE: 'CAPITAL_DECREASE',
  CAPITAL_INCREASE: 'CAPITAL_INCREASE',
  CONSTITUTION: 'CONSTITUTION',
  DIVIDENDS_DISTRIBUTION: 'DIVIDENDS_DISTRIBUTION',
  DONATION: 'DONATION',
  HERITAGE: 'HERITAGE',
  RECLASSIFICATION: 'RECLASSIFICATION',
  RENUMERATION: 'RENUMERATION',
  SELL_PARTICIPATION: 'SELL_PARTICIPATION',
  SPLIT: 'SPLIT',
  CONTRIBUTION: 'CONTRIBUTION',
  ENDORSEMENT: 'ENDORSEMENT',
  TRANSMISSION: 'TRANSMISSION',
  INFORMATIONAL: 'INFORMATIONAL',
};
